
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({
  filters: {
    formatNum (value: number) {
      return value.toLocaleString('en')
    }
  }
})
export default class TableKpiCompareItem extends Vue {
  @Prop({ required: true, default: 0 })
  amount: number

  @Prop({ required: true, default: 0 })
  total: number

  @Prop({ required: false, default: 'yellow' })
  barColor: string

  @Prop({ required: false, default: 'blue' })
  color: string

  average = 0
  restAverage = 0
  restAmount = 0
  percentAnimOver = false;

  mounted () {
    this.calc()
  }

  calc () {
    this.average = this.amount / this.total * 100
    this.restAverage = 100 - this.average
    this.restAmount = this.total - this.amount
  }

  get formatttedAverage () {
    return this.average.toFixed(1)
  }

  get formatttedRestAverage () {
    return this.restAverage.toFixed(1)
  }

  @Watch('total')
  watchTotal () {
    this.calc()
  }

  @Watch('amount')
  watchAmount () {
    this.calc()
  }
}
